import { render, staticRenderFns } from "./ReservationAdmin.vue?vue&type=template&id=eb57bbe4&scoped=true&"
import script from "./ReservationAdmin.vue?vue&type=script&lang=js&"
export * from "./ReservationAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ReservationAdmin.vue?vue&type=style&index=0&id=eb57bbe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb57bbe4",
  null
  
)

export default component.exports